import { render, staticRenderFns } from "./contractTips.vue?vue&type=template&id=0b8d4571&scoped=true"
var script = {}
import style0 from "./contractTips.vue?vue&type=style&index=0&id=0b8d4571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d4571",
  null
  
)

export default component.exports